<template lang="pug">
    div.shop-setting(
        v-loading="loading"
    )
        div(v-if="render")
            el-form(
                :model="formData"
                :rules="rules"
                ref="form"
                label-width="140px"
            )
                div.title 基本信息
                el-form-item(label="店铺全称：")
                    span {{ shopFullName }}
                el-form-item(
                    label="店铺别名："
                    prop="aliasName"
                )
                    el-input(
                        class="width500"
                        v-model.trim="formData.aliasName"
                        placeholder="请输入"
                        maxlength="50"
                        clearable
                        @blur="getValidateRes('aliasName')"
                    )
                    div.el-form-item-tips(v-if="!aliasNameError") ps : 该名称直接用于展示给客户
                div.address-tips 定位点将作为判断客户到店及客户导航地址的参考，请在地图上搜索准确的位置
                el-form-item(
                    label="售后位置地址："
                    prop="location"
                )
                    p {{ formData.location.addr ? `${formData.location.regionName || ''}${formData.location.addr}` : '暂无地址' }}
                    div.map-container(v-if="showAmap")
                        Amap(
                            ref="amap"
                            @getShopAddress="getShopAddress"
                            :id="1"
                            :showClose="false"
                            :defaultMarker="defaultAddr1"
                            :height="313"
                        )
                el-form-item(
                    label="钣金车间地址："
                    prop="repairLocation"
                )
                    p {{ formData.repairLocation.addr ? `${formData.repairLocation.regionName || ''}${formData.repairLocation.addr}` : '暂无地址' }}
                    div.map-container(v-if="showAmap")
                        Amap(
                            ref="amap2"
                            @getShopAddress="getRepairLocation"
                            :id="2"
                            :showClose="false"
                            :defaultMarker="defaultAddr2"
                            :height="313"
                        )
                el-form-item(
                    label="店铺图片："
                )
                    template
                        div.add-img-container
                            Clipping(
                                :imgWidth="375"
                                :imgHeight="175"
                                :photo="photoFullPath"
                                @getImg="getImg"
                                ref="clipPic"
                            )
                            div.add-img-tips
                                span 格式：JPG，PNG
                                span 大小：小于2M
                                span 规格：{{750 }}*{{ 350 }}
                el-form-item(
                    label="服务品牌："
                    prop="serviceBrands"
                )
                    el-select(
                        class="width500"
                        clearable
                        multiple
                        filterable
                        remote
                        v-model="formData.serviceBrands"
                        value-key="id"
                        placeholder="请输入车辆品牌"
                        :remote-method="remoteMethod"
                        :loading="remoteLoading"
                        @blur="getValidateRes('serviceBrands')"
                    )
                        el-option(
                            v-for="item in options"
                            :key="item.id"
                            :label="item.name"
                            :value="item"
                        )
                el-form-item(
                    label="店铺电话："
                    prop="phone"
                )
                    el-input(
                        class="width500"
                        v-model.trim="formData.phone"
                        placeholder="请输入"
                        maxlength="15"
                        clearable
                        @blur="getValidateRes('phone')"
                    )
                el-form-item(
                    label="售后电话："
                    prop="afterSalesPhone"
                )
                    el-input(
                        class="width500"
                        v-model.trim="formData.afterSalesPhone"
                        placeholder="请输入"
                        maxlength="15"
                        clearable
                        @blur="getValidateRes('afterSalesPhone')"
                    )
                div.title 碰撞线索
                el-form-item(
                    label="疑似碰撞消息："
                    prop="recvSuspectedCollision"
                )
                    el-radio-group(v-model="formData.recvSuspectedCollision")
                        el-radio(:label="false") 不接收
                        el-radio(:label="true") 接收
                el-form-item(
                    label="关怀型碰撞消息："
                    prop="recvCareCollision"
                )
                    el-radio-group(v-model="formData.recvCareCollision")
                        el-radio(:label="false") 不接收
                        el-radio(:label="true") 接收
                div.connector
                    el-form-item(
                        label="24小时救援电话："
                        prop="collisionContactPerson"
                    )
                        el-input(
                            class="width200"
                            v-model.trim="formData.collisionContactPerson"
                            placeholder="请填写姓名"
                            clearable
                            maxlength="64"
                        )
                    el-form-item(
                        label-width="0px"
                        prop="collisionContactPhone"
                    )
                        ElIntegerInput(
                            class="width290"
                            v-model.trim="formData.collisionContactPhone"
                            placeholder="请填写手机号码"
                            maxlength="11"
                            clearable
                        )
            div.btns
                el-button(
                    round
                    @click="resetForm"
                    :disabled="!getAuthority('ShopSetting', 'Update')"
                ) 重置
                el-button(
                    round
                    type="primary"
                    @click="handleSubmit"
                    :disabled="!getAuthority('ShopSetting', 'Update')"
                ) 保存
</template>
<script>
/* eslint-disable */
    import { shopSettingApis, } from '@/api';
    import Amap from './Amap.vue';
    import { regexpUtils, } from '@/utils';
    import oss from '@/utils/oss';
    import ElIntegerInput from '@/components/elementUi/diy/ElIntegerInput.vue';
    import { mapState, mapGetters, } from 'vuex';
    import Clipping from './Clipping';

    export default {
        components: {
            Amap,
            Clipping,
            ElIntegerInput,
        },
        props: {    
            type: {
                type: String,
                default: 'page',
            },
        },
        data() {
            const validateLinePhone = (rule, value, callback) => {
                if (value && !regexpUtils.linePhoneNumberEasy(value).res) {
                    callback(new Error(regexpUtils.linePhoneNumberEasy(value).message));
                } else {
                    callback();
                }
            };
            return {
                defaultAddr1: {},
                defaultAddr2: {},
                loading: true,
                aliasNameError: false,
                render: true,
                formData: {
                    aliasName: '',
                    location: '',
                    repairLocation: '',
                    photo: '',
                    serviceBrands: [],
                    phone: '',
                    afterSalesPhone: '',
                    recvSuspectedCollision: '',
                    recvCareCollision: '',
                    collisionContactPerson: '',
                    collisionContactPhone: '',
                },
                photoFullPath: '',
                addressOptions: [],
                cascaderProps: {
                    value: 'id',
                    label: 'name',
                },
                options: [],
                remoteLoading: false,
                rules: {
                    aliasName: [
                        {
                            required: true,
                            message: '请填写店铺简称',
                            trigger: 'blur',
                        },
                    ],
                    location: {
                        required: true,
                        message: '请选择售后位置地址',
                        trigger: 'blur',
                        validator: (rule, value, callback) => {
                            if (value.latitude && value.longitude) callback();
                            else callback(new Error('请选择售后位置地址'));
                        },
                    },
                    serviceBrands: [
                        {
                            required: true,
                            message: '请选择服务品牌',
                            trigger: 'change',
                        },
                    ],
                    phone: [
                        {
                            required: true,
                            message: '请填写店铺电话',
                            trigger: 'blur',
                        },
                        { 
                            validator: validateLinePhone, 
                            trigger: 'blur',
                        },
                    ],
                    afterSalesPhone: [
                        {
                            required: true,
                            message: '请填写售后电话',
                            trigger: 'blur',
                        },
                        { 
                            validator: validateLinePhone, 
                            trigger: 'blur',
                        },
                    ],
                    recvSuspectedCollision: [
                        {
                            required: true,
                            message: '请设置是否接收疑似碰撞消息',
                            trigger: 'blur',
                        },
                    ],
                    recvCareCollision: [
                        {
                            required: true,
                            message: '请设置是否接收关怀型碰撞消息',
                            trigger: 'blur',
                        },
                    ],
                    collisionContactPerson: [
                        {
                            required: true,
                            message: '请填写救援联系人姓名',
                            trigger: 'blur',
                        },
                    ],
                    collisionContactPhone: [
                        {
                            required: true,
                            message: '请填写正确的手机号码',
                            trigger: 'blur',
                        },
                        {
                            pattern: /^(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])\d{8}$/,
                            message: '请填写正确的手机号码',
                            trigger: 'blur',
                        },
                    ],
                },
                showAmap: false,
            };
        },
        computed: {
            ...mapGetters('user', [
                'getAuthority',
            ]),
            ...mapState('user', [
                'userInfo',
            ]),
            shopFullName() {
                const currentOrg = this.userInfo.orgs.find(val => val.orgId === this.userInfo.lastLoginOrgId);
                return currentOrg.orgName || '--';
            },
        },
        watch: {
            'formData.location'() {
                if (this.type === 'dialog') this.getValidateRes('location');
            },
        },
        methods: {
            async remoteMethod(query) {
                if (query !== '') {
                    this.remoteLoading = true;
                    await shopSettingApis.getBrands({
                        brandName: query,
                    })
                        .then(({ data, }) => {
                            if (data.list.length) {
                                const res = data.list.map(val => {
                                    return {
                                        name: val.name,
                                        id: val.id,
                                    };
                                });
                                const arr = [
                                    ...res,
                                    ...this.formData.serviceBrands,
                                ];
                                const tmp = new Map();
                                this.options = arr.filter(val => !tmp.has(val.id) && tmp.set(val.id, 1));
                            } 
                        })
                        .catch(err => {
                            throw new Error(err);
                        })
                        .finally(() => {
                            this.remoteLoading = false;
                        });
                }
            },
            // 经纬度 POIID
            getShopAddress(res) {
                this.formData.location = {
                    latitude: res.lat,
                    longitude: res.lng,
                    poiId: res.POIId,
                    addr: res.address,
                    regionId: res.adcode,
                    regionName: res.regionName,
                };
            },
            getRepairLocation(res) {
                this.formData.repairLocation = {
                    latitude: res.lat,
                    longitude: res.lng,
                    poiId: res.POIId,
                    addr: res.address,
                    regionId: res.adcode,
                    regionName: res.regionName,
                };
            },
            async getImg(val) {
                const res = await oss.downloadFile(val, 'PUBLIC');
                this.photoFullPath = res ? res : this.photoFullPath;
                // 上传广告图片成功后返回的路径回调
                this.formData.photo = val;
            },
            getValidateRes(prop) {
                if (!this.$refs.form) return;
                this.$refs.form.validateField(prop, val => {
                    this[`${prop}Error`] = val;
                });
            },
            async initData(val) {
                const data = JSON.parse(JSON.stringify(val));

                this.options = data.servedBrands || [];
                this.defaultAddr2 = {
                    latitude: data.repairAddress && data.repairAddress.latitude ? data.repairAddress.latitude : null,
                    longitude: data.repairAddress && data.repairAddress.longitude ? data.repairAddress.longitude : null,
                };
                this.defaultAddr1 = {
                    latitude: data.address.latitude || null,
                    longitude: data.address.longitude || null,
                };
                this.$nextTick(() => { this.showAmap = true; });
                
                this.formData = {
                    aliasName: data.aliasName,
                    location: { ...data.address, },
                    repairLocation: { ...data.repairAddress, },
                    serviceBrands: data.servedBrands || [],
                    phone: data.phone,
                    afterSalesPhone: data.afterSalesPhone,
                    photo: data.photo,
                    recvSuspectedCollision: Object.keys(data).includes('recvSuspectedCollision') ? data.recvSuspectedCollision: false,
                    recvCareCollision: Object.keys(data).includes('recvCareCollision') ? data.recvCareCollision: false,
                    collisionContactPerson: data.collisionContactPerson,
                    collisionContactPhone: data.collisionContactPhone,
                };
                
                if (data.photo) {
                    const url = await oss.downloadFile(data.photo, 'PUBLIC');
                    this.photoFullPath = url;
                } else {
                    this.photoFullPath = '';
                }
            },
            async getShopInfo() {
                if (this.getAuthority('ShopSetting', 'Read')) {
                    this.loading = true;
                    await shopSettingApis.getShopInfo({
                        id: this.userInfo.lastLoginOrgId,
                    })
                        .then(({ data, }) => {
                            this.initData(data)
                        })
                        .catch(err => {
                            throw new Error(err);
                        })
                        .finally(() => {
                            this.loading = false;
                            this.$nextTick(() => {
                                this.$refs.form.clearValidate();
                            });
                        });
                }
            },
            async editShopInfo(params) {
                if (this.getAuthority('ShopSetting', 'Update')) {
                    this.loading = true;
                    await shopSettingApis.editShopInfo({
                        ...params,
                    })
                        .then(() => {
                            this.$emit('setInfoSuccess');
                            this.getShopInfo();
                            this.$message({
                                type: 'success',
                                message: '保存成功！',
                            });
                        })
                        .catch(err => {
                            throw new Error(err);
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                }
            },
            resetForm() {
                this.aliasNameError = false;
                this.$refs.form.resetFields();
                this.getShopInfo();
            },
            handleSubmit() {
                if (!this.getAuthority('ShopSetting', 'Update')) return;
                this.$refs.form.validate(async (valid, obj) => {
                    if (obj.aliasName) this.aliasNameError = true;
                    if (!valid) return;
                    this.editShopInfo(this.handleParams());
                });
            },
            handleParams() {
                const params = {
                    aliasName: this.formData.aliasName,
                    photo: this.formData.photo,
                    phone: this.formData.phone,
                    afterSalesPhone: this.formData.afterSalesPhone,
                    address: {
                        ...this.formData.location,
                    },
                    repairAddress: {
                        ...this.formData.repairLocation,
                    },
                    servedBrands: this.formData.serviceBrands,
                    recvSuspectedCollision: this.formData.recvSuspectedCollision,
                    recvCareCollision: this.formData.recvCareCollision,
                    collisionContactPerson: this.formData.collisionContactPerson,
                    collisionContactPhone: this.formData.collisionContactPhone,
                };
                return params;
            },
        },
        mounted() {
            this.getShopInfo();
        },
    };
</script>
<style lang="scss" scoped>
    .shop-setting {
        width: 670px;
        min-height: 1000px;
        .address-tips {
            width: 642px;
            height:36px;
            background: #FFF0D9;
            color: #FF9F00;
            font-size: 12px;
            text-align: center;
            padding-left: 20px;
            line-height: 36px;
            margin: 10px 0 10px 20px;
        }
        .title {
            width: 680px;
            height:40px;
            background: #F9FAFC;
            padding-left: 20px;
            line-height: 40px;
            margin-bottom: 10px;
        }
        .connector {
            display: flex;
        }
        .btns {
            display: flex;
            justify-content: center;
            margin: 0 0 20px;
            button {
                width: 120px;
                height: 36px;
                border-radius: 18px;
            }
            button + button {
                margin-left: 60px;
            }
        }
    }
</style>
<style lang="scss">
    .shop-setting {
        .el-form {
            .width500 {
                width: 500px;
            }
            .width290 {
                flex-shrink: 0;
                width: 290px;
            }
            .width200 {
                flex-shrink: 0;
                width: 200px;
            }
            .el-form-item {
                padding-left: 20px;
            }
            p {
                @include font_color(text_color_gray3);
            }
            .map-container {
                margin-top: 10px;
                width: 501px;
            }
            .Customer-Amap .search-service {
                left: 20px;
                top: 60px;
            }
            .add-img-container {
                width: 501px;
                height: 195px;
                border: 1px solid;
                @include border_color(color_base_gray5);
                border-radius: 4px;
                padding: 10px;
                display: flex;
                .add-img-tips {
                    flex: auto;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    margin-left: 10px;
                    line-height: 20px;
                    @include font_color(text_color_gray3);
                    @include font_size(text_very_small);
                    &>span {
                        width: 111px;
                    }
                }
            }
            .el-form-item-tips {
                @include font_color(text_color_gray);
                font-size: 12px;
                line-height: 1;
                padding-top: 4px;
                position: absolute;
                top: 100%;
                left: 0;
            }
            .el-cascader {
                line-height: 32px;
            }
        }
    }
</style>
